<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>欠费减免审核</span>
        <div>
          <el-radio-group v-model="query.state" size="small" @change="loadList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="1100">待审核</el-radio-button>
            <el-radio-button label="1200">已通过</el-radio-button>
            <el-radio-button label="1300">已驳回</el-radio-button>
            <el-radio-button label="1000">已撤回</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="filter-container">
        <el-input v-model="query.feeName" placeholder="费用项目名" clearable size="small"
          style="width:160px" @keyup.enter.native="loadList" />
        <el-button type="primary" size="small" @click="loadList">查询</el-button>
      </div>

      <el-table :data="list" border stripe size="small" v-loading="loading" style="width:100%">
        <el-table-column label="申请单号" prop="auditId" align="center" width="160" />
        <el-table-column label="房屋/车辆" align="center" width="120">
          <template #default="{row}">
            <span>{{ row.payerObjType === '3333' ? (row.roomNum || '-') : ('车位:' + (row.roomNum || row.payerObjId || '-')) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="费用项目" prop="feeName" align="center" min-width="100" />
        <el-table-column label="费用月份" align="center" width="210">
          <template #default="{row}">{{ formatMonth(row.feeStartTime || row.startTime) }}~{{ formatMonth(row.feeEndTime || row.endTime) }}</template>
        </el-table-column>
        <el-table-column label="申请减免" align="center" width="90">
          <template #default="{row}">
            <span style="color:#F56C6C;font-weight:bold">{{ parseFloat(row.deductionAmount||0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请人" align="center" width="90">
          <template #default="{row}">{{ row.applyUserName || row.applyUserId || '-' }}</template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" width="145">
          <template #default="{row}">{{ formatTime(row.applyTime) }}</template>
        </el-table-column>
        <el-table-column label="减免原因" prop="message" align="center" min-width="160" show-overflow-tooltip />
        <el-table-column label="状态" align="center" width="80">
          <template #default="{row}">
            <el-tag :type="stateTagType(row.state)" size="mini">{{ stateText(row.state) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核人" prop="auditUserName" align="center" width="90" />
        <el-table-column label="审核时间" align="center" width="145">
          <template #default="{row}">{{ formatTime(row.auditTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template #default="{row}">
            <template v-if="row.state === '1100'">
              <el-button type="text" size="small" style="color:#67C23A" @click="audit(row, '1200')">通过</el-button>
              <el-button type="text" size="small" style="color:#F56C6C" @click="audit(row, '1300')">驳回</el-button>
            </template>
            <span v-else style="color:#909399">-</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="query.page"
        :page-size="query.row"
        @current-change="loadList"
        style="margin-top:12px;text-align:right"
      />
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listFeeDeductionApply, auditFeeDeduction } from '@/api/fee/feeDeductionApi'

export default {
  name: 'FeeDeductionAuditList',
  data() {
    return {
      communityId: '',
      loading: false,
      list: [],
      total: 0,
      query: {
        state: '1100',
        feeName: '',
        page: 1,
        row: 15
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.loadList()
  },
  methods: {
    async loadList() {
      this.loading = true
      try {
        const res = await listFeeDeductionApply({
          communityId: this.communityId,
          state: this.query.state,
          page: this.query.page,
          row: this.query.row
        })
        this.list = res.applys || []
        this.total = res.total || 0
      } catch (e) {
        console.error('加载减免申请列表失败', e)
      }
      this.loading = false
    },
    async audit(row, state) {
      let message = ''
      try {
        if (state === '1200') {
          await this.$confirm(
            `确认「通过」该减免申请？<br/>费用项目：${row.feeName}<br/>减免金额：${parseFloat(row.deductionAmount || 0).toFixed(2)} 元<br/>通过后该欠费将被清减，操作不可撤销。`,
            '减免审核确认',
            { dangerouslyUseHTMLString: true, confirmButtonText: '确认通过', cancelButtonText: '取消', type: 'warning' }
          )
        } else {
          const { value } = await this.$prompt('请输入驳回原因', '驳回减免申请', {
            confirmButtonText: '确认驳回',
            cancelButtonText: '取消',
            inputType: 'textarea',
            inputPlaceholder: '驳回原因（必填）',
            inputValidator: (v) => (v && v.trim()) ? true : '请填写驳回原因'
          })
          message = value.trim()
        }
      } catch (e) {
        return // 用户取消
      }

      try {
        await auditFeeDeduction({
          communityId: this.communityId,
          auditId: row.auditId,
          state: state,
          message: message
        })
        this.$message.success(state === '1200' ? '已通过，减免已生效' : '已驳回')
        this.loadList()
      } catch (e) {
        const msg = (e && (e.msg || e.message)) || '审核失败'
        this.$message.error(msg)
      }
    },
    stateText(state) {
      return { '1100': '待审核', '1200': '已通过', '1300': '已驳回', '1000': '已撤回' }[state] || state
    },
    stateTagType(state) {
      return { '1100': 'warning', '1200': 'success', '1300': 'danger', '1000': 'info' }[state] || ''
    },
    formatTime(t) {
      if (!t) return '-'
      return String(t).replace('T', ' ').substring(0, 19)
    },
    // 日期格式化：显示 YYYY-MM-DD
    formatMonth(t) {
      if (!t) return '-'
      return String(t).replace('T', ' ').substring(0, 10)
    }
  }
}
</script>

<style scoped>
.app-container { padding: 20px; }
.filter-container { margin-bottom: 12px; }
.filter-container .el-input { margin-right: 8px; }
</style>
